import "@/App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Leistungen from "@/pages/Leistungen";
import Handyreparatur from "@/pages/Handyreparatur";
import Kontakt from "@/pages/Kontakt";
import AGB from "@/pages/AGB";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import NotFound from "@/pages/NotFound";

function App() {
    return (
        <div className="App">
            <HashRouter>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/leistungen" element={<Leistungen />} />
                        <Route path="/handyreparatur" element={<Handyreparatur />} />
                        <Route path="/kontakt" element={<Kontakt />} />
                        <Route path="/agb" element={<AGB />} />
                        <Route path="/impressum" element={<Impressum />} />
                        <Route path="/datenschutz" element={<Datenschutz />} />
                        <Route path="*" element={<NotFound />} />
                    </Route>
                </Routes>
            </HashRouter>
            <Toaster
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#1C1917",
                        color: "#F8F6F0",
                        border: "1px solid #3f3f3a",
                        borderRadius: "2px",
                        fontFamily: "Manrope, sans-serif",
                    },
                }}
            />
        </div>
    );
}

export default App;
